import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestStatusGet = {
    path: "/status",
    method: RouteHttpVerb.GET
};
export { locationRestStatusGet };
